import { render, staticRenderFns } from "./page-header-search.vue?vue&type=template&id=143e8546&scoped=true"
import script from "./page-header-search.vue?vue&type=script&lang=js"
export * from "./page-header-search.vue?vue&type=script&lang=js"
import style0 from "./page-header-search.vue?vue&type=style&index=0&id=143e8546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e8546",
  null
  
)

export default component.exports